export const getTzip10Link = (url, payload) => `${url}?type=tzip10&data=${payload}`;
//# sourceMappingURL=get-tzip10-link.js.map